/*   no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useContext, useState } from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import { updateProfilePicFunc } from "../../store/ducks/auth.duck";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import IconButton from "@mui/material/IconButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { withSnackbar } from "notistack";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from "@mui/material/CircularProgress";

import "firebase/auth";
import "firebase/functions";
import { AuthContext } from "../../../AuthContextProvider";
import Spinner from "../spinner";
import WalletService from "../../../services/relysia-queries";
import WalletConfig from "../../../services/wallet";

const QuickPanel = (props) => {
  const {
    userWallet,
    userContextApi,
    setUserContextApi,
    userWalletStats,
    setUserWallet,
    setUserWalletStats,
  } = useContext(AuthContext);
  const [refresh, setRefresh] = useState(false);

  const refreshMetrices = async () => {
    setRefresh(true);
    await WalletService.getwalletDetails(
      "00000000-0000-0000-0000-000000000000",
      setUserWallet
    ).then(() => {
      WalletConfig.mnemonicFromString(
        window.bsvMnemonic,
        userWallet.Mnemonic,
        window.bsv,
        1,
        setUserWalletStats
      );
      setRefresh(false);
    });
  };

  return (
    <div>
      <div>
        <div
          className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("media/bg/bg-11.jpg")})`,
            height: 60,
          }}
        >
          <div className="kt-user-card__name">
            Wallet Data
            <IconButton color="secondary" onClick={() => refreshMetrices()}>
              {refresh ? (
                <CircularProgress color="secondary" size={14} thickness={4.2} />
              ) : (
                <RefreshIcon style={{ fontSize: 18 }} />
              )}
            </IconButton>
          </div>
        </div>
        <div>
          <div
            style={{
              width: "100%",
              padding: 20,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ width: "60%", fontSize: 12, fontWeight: 600 }}
            >
              Wallet Balance in Satoshi
            </Typography>
            <Typography
              variant="subtitle1"
              color="secondary"
              style={{
                textAlign: "right",
                fontSize: 12,
                marginLeft: "auto",
                fontWeight: 600,
              }}
            >
              {userWallet.Balance ?? <Spinner />}
            </Typography>
          </div>
          <Divider />
          <div
            style={{
              width: "100%",
              padding: 20,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ width: "60%", fontSize: 12, fontWeight: 600 }}
            >
              Wallet Balance in $
            </Typography>
            <Typography
              variant="subtitle1"
              color="secondary"
              style={{
                textAlign: "right",
                marginLeft: "auto",
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              ${" "}
              {(userWallet.Balance &&
                (parseFloat(props.usdBalance) * 100000000).toFixed(3)) ?? (
                  <Spinner />
                )}
            </Typography>
          </div>
          <Divider />
          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("media/bg/bg-11.jpg")})`,
              height: 60,
            }}
          >
            <div className="kt-user-card__name"> Wallet Keys</div>
          </div>
          <Divider />
          <div className="w-full p-4 flex items-center">
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ width: "60%", fontSize: 12, fontWeight: 600 }}
            >
              Auth Token
              <CopyToClipboard
                text={userContextApi.authToken ?? ""}
                onCopy={() =>
                  props.enqueueSnackbar("Auth Token has been copied", {
                    variant: "info",
                  })
                }
              >
                <IconButton size="small">
                  <FileCopyIcon />
                </IconButton>
              </CopyToClipboard>
            </Typography>

            <Typography
              variant="subtitle2"
              color="secondary"
              style={{
                textAlign: "left",
                marginLeft: "auto",
                fontSize: 12,
                wordBreak: "break-word",
              }}
            >
              {userContextApi.authToken?.substring(0, 60) + "..." ?? (
                <Spinner />
              )}
            </Typography>
          </div>
          <div className="w-full p-4 flex items-center">
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ width: "60%", fontSize: 12, fontWeight: 600 }}
            >
              Private Key
              <CopyToClipboard
                text={userWalletStats.privateKey ?? ""}
                onCopy={() =>
                  props.enqueueSnackbar("Private Key has been copied", {
                    variant: "info",
                  })
                }
              >
                <IconButton size="small">
                  <FileCopyIcon />
                </IconButton>
              </CopyToClipboard>
            </Typography>

            <Typography
              variant="subtitle2"
              color="secondary"
              style={{
                textAlign: "left",
                marginLeft: "auto",
                fontSize: 12,
                wordBreak: "break-word",
              }}
            >
              {userWalletStats.privateKey ?? <Spinner />}
            </Typography>
          </div>
          <div className="w-full p-4 flex items-center">
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ width: "60%", fontSize: 12, fontWeight: 600 }}
            >
              Public Key
              <CopyToClipboard
                text={userWalletStats.publicKey ?? ""}
                onCopy={() =>
                  props.enqueueSnackbar("Public Key has been copied", {
                    variant: "info",
                  })
                }
              >
                <IconButton size="small">
                  <FileCopyIcon />
                </IconButton>
              </CopyToClipboard>
            </Typography>

            <Typography
              variant="subtitle2"
              color="secondary"
              style={{
                textAlign: "left",
                fontSize: 12,
                marginLeft: "auto",
                wordBreak: "break-word",
              }}
            >
              {userWalletStats.publicKey ?? <Spinner />}
            </Typography>
          </div>
          <div className="w-full p-4 flex items-center">
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{
                width: 75,
                marginRight: 15,
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              <span>Address </span>
              <CopyToClipboard
                text={userWallet.Address ?? ""}
                onCopy={() =>
                  props.enqueueSnackbar("Address Key has been copied", {
                    variant: "info",
                  })
                }
              >
                <IconButton size="small">
                  <FileCopyIcon />
                </IconButton>
              </CopyToClipboard>
            </Typography>

            <Typography
              variant="subtitle2"
              color="secondary"
              style={{ fontSize: 12 }}
            >
              {userWallet.Address ?? <Spinner />}
            </Typography>
          </div>
          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("media/bg/bg-11.jpg")})`,
              height: 60,
            }}
          >
            <div className="kt-user-card__name"> UTXO Sets </div>
          </div>
          <Divider />
          <table style={{ width: "100%", tableLayout: "fixed", fontSize: 13 }}>
            <tbody>
              <tr style={{ fontSize: 14 }}>
                <th
                  style={{
                    width: "30%",
                    wordBreak: "break-word",
                    backgroundColor: "#F8F8FF",
                    paddingLeft: 3,
                  }}
                >
                  {" "}
                  Value{" "}
                </th>
                <th
                  style={{
                    width: "10%",
                    wordBreak: "break-word",
                    paddingLeft: 3,
                  }}
                >
                  {" "}
                  Vout{" "}
                </th>
                <th
                  style={{
                    width: "30%",
                    wordBreak: "break-word",
                    backgroundColor: "#F8F8FF",
                    paddingLeft: 3,
                  }}
                >
                  {" "}
                  Txid{" "}
                </th>
                <th
                  style={{
                    width: "30%",
                    wordBreak: "break-word",
                    paddingLeft: 3,
                  }}
                >
                  {" "}
                  ScriptPubKey{" "}
                </th>
              </tr>
              {userWallet.Uxto &&
                userWallet.Uxto.data?.userUtxos?.length > 0 ?
                userWallet.Uxto.data.userUtxos.map((item, index) => {
                  return (
                    <tr key={index + "txo"} style={{ height: 70 }}>
                      <td
                        style={{
                          width: "12%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingLeft: 3,
                          backgroundColor: "#F8F8FF",
                        }}
                      >
                        {item.value}
                      </td>
                      <td
                        style={{
                          width: "8%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 3,
                        }}
                      >
                        {item.tx_pos}
                      </td>
                      <td
                        style={{
                          width: "40%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 3,
                          backgroundColor: "#F8F8FF",
                        }}
                      >
                        {item.tx_hash}
                      </td>
                      <td
                        style={{
                          width: "40%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 5,
                          paddingLeft: 3,
                        }}
                      >
                        {item.script}
                      </td>
                    </tr>
                  )
                })
                :
                userWallet.Uxto?.data?.data?.userUtxos.map((item, index) => {
                  return (
                    <tr key={index + "txo"} style={{ height: 70 }}>
                      <td
                        style={{
                          width: "12%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingLeft: 3,
                          backgroundColor: "#F8F8FF",
                        }}
                      >
                        {item.value}
                      </td>
                      <td
                        style={{
                          width: "8%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 3,
                        }}
                      >
                        {item.tx_pos}
                      </td>
                      <td
                        style={{
                          width: "40%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 3,
                          backgroundColor: "#F8F8FF",
                        }}
                      >
                        {item.tx_hash}
                      </td>
                      <td
                        style={{
                          width: "40%",
                          wordBreak: "break-word",
                          verticalAlign: "baseline",
                          marginTop: 10,
                          paddingRight: 5,
                          paddingLeft: 3,
                        }}
                      >
                        {item.script}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("media/bg/bg-11.jpg")})`,
              height: 60,
            }}
          >
            <div className="kt-user-card__name"> Explorer </div>
          </div>
          <Button
            target="_blank"
            href={
              "https://whatsonchain.com/address/" + userWalletStats.wallAddress
            }
            style={{ backgroundColor: "orange", padding: 15, margin: 5 }}
          >
            WhatsOnChain
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  auth: { user, updateProfilePic, profilePicUrl, updateTutorStatus },
}) => ({
  user,
  updateProfilePic,
  profilePicUrl,
  updateTutorStatus,
});

export default withSnackbar(
  connect(mapStateToProps, { updateProfilePicFunc })(QuickPanel)
);
